<template>
  <time :datetime="html" :title="long">{{ short }}</time>
</template>

<script lang="ts" setup>
defineProps<{
  // 31.01.2023
  short: string
  // Dienstag, 31. Januar 2023 - 16:39
  long: string
  // 2023-01-31T16:39:02+0100
  html: string
}>()
</script>
